import React, { useState } from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import { pageFadeIn } from "../../../utils/animations";
import NavBar from "../../../Components/Navbar/NavBar";
import SalesLAC from "./SalesLAC";
import ReportsLAC from "./ReportsLAC";
import lac_logo from "../../../Assets/lac_logo.png";
import axios from "axios";

const LAC = () => {
  const [selectedOption, setSelectedOption] = useState("Sales");
  
  const handleTabClick = async (tab) => {
    setSelectedOption(tab);
    const resJWTTableau = await axios.get(
      `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
      { withCredentials: true }
    );
    localStorage.setItem("tableauToken", resJWTTableau.data);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <SalesLAC content="Sales LAC" color="red" />;
      case "Reports":
        return <ReportsLAC content="Reports LAC" />;
      default:
        return <SalesLAC content="Sales LAC" color="red" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar 
        tabIndicatorColor="red.500" 
        logo={lac_logo} 
        onTabClick={handleTabClick} 
      />
      
      <Box
      w="100%"
      h="calc(100vh - 60px)"
      overflow="hidden"
      bgColor="white"
      bgImage={`linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.88)), url(${lac_logo})`}
      bgRepeat="no-repeat"
      bgSize="40% auto"
      bgPosition="right -80px"
      sx={{ animation: `${pageFadeIn} 0.55s ease both` }}
    >
        {renderContent()}
      </Box>
    </Box>
  );
};

export default LAC;
